/* eslint-disable no-console */
import axios from 'axios';
import { Auth } from '@aws-amplify/auth';
import { appConfig } from '../config/app-config';

const CONTENT_TYPE = 'application/json; charset=UTF-8';

export async function getJWToken(): Promise<string> {
  try {
    const session = await Auth.currentSession();
    return session.getIdToken().getJwtToken();
  } catch (error) {
    throw new Error(`Error getting JWT token: ${error}`);
  }
}

export async function getAccessToken(): Promise<string> {
  try {
    const session = await Auth.currentSession();
    return session.getAccessToken().getJwtToken();
  } catch (error) {
    console.error('Error getting access token:', error);
    throw new Error(`Error getting access token: ${error}`);
  }
}

function buildHeaders({
  jwtToken,
  accessToken,
  needAccessToken = false,
}: {
  jwtToken?: string;
  accessToken?: string;
  needAccessToken?: boolean;
}) {
  const headers: Record<string, string> = {
    'Content-Type': CONTENT_TYPE,
  };

  headers.storeNumber = window.sessionStorage.getItem('storeNumber') || '00000';

  if (jwtToken) {
    headers.Authorization = `Bearer ${jwtToken}`;
  }

  if (needAccessToken && accessToken) {
    headers.AccessToken = accessToken;
  }

  return headers;
}

export async function apiClient({
  endpoint,
  apiUrl = appConfig.apiUrls.micro,
  requestType = 'GET',
  body,
  customConfig = {},
  needAccessToken = true,
}: {
  endpoint: string;
  apiUrl?: string;
  requestType?: string;
  body?: any;
  customConfig?: any;
  needAccessToken?: boolean;
}) {
  const jwtToken = await getJWToken();
  const accessToken =
    window.sessionStorage.getItem('ac') ||
    (needAccessToken ? await getAccessToken() : undefined);

  const headers = buildHeaders({ jwtToken, accessToken, needAccessToken });

  const config = {
    method: requestType,
    url: `${apiUrl}/${endpoint}`,
    headers: { ...headers, ...customConfig.headers },
    ...customConfig,
    ...(body && { data: JSON.stringify(body) }),
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error: any) {
    console.error('API Error:', error);
    return error.response;
  }
}
